export default __webpack_public_path__ + "static/media/ic_img_all.d59f7f8d.svg";